import { semantical } from 'src/theme/tokens/semantical';

export const appTheme = {
  background: semantical.colors.background.neutral.intense,
  // UI shadows with light theme
  boxShadow: semantical.shadows.none,
  color: semantical.colors.text.neutral.weakest,
  font: semantical.fonts.family.body,
} as const;
